import {
  COMENZAR_RECORDAR_CONTRASENA,
  EVENTO_RECORDAR_CONTRASENA_ERROR,
  EVENTO_RECORDAR_CONTRASENA_EXITO,
  RESET_ERROR_RECORDAR_CONTRASENA,
} from "../types";

import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

export function recordarContrasenaAction(credenciales) {
  return async (dispatch) => {
    dispatch(recordarContrasenaEvento());
    let params = { email: credenciales.usuario };
    await clienteAxios
      .post(`/login/recordarcontrasena`, params)
      .then((respuesta) => {
        dispatch(recordarContrasenaEventoExitosa(respuesta.data));
      })
      .catch((err) => {
        dispatch(recordarContrasenaEventoError(handlerError(err)));
      });
  };
}

export function resetRecordarContrasenaAction() {
  return async (dispatch) => {
    dispatch(resetRecordarContrasenaEvento());
  };
}

const recordarContrasenaEvento = () => ({
  type: COMENZAR_RECORDAR_CONTRASENA,
  payload: true,
});

const recordarContrasenaEventoError = (error) => ({
  type: EVENTO_RECORDAR_CONTRASENA_ERROR,
  payload: error,
});

const recordarContrasenaEventoExitosa = (data) => ({
  type: EVENTO_RECORDAR_CONTRASENA_EXITO,
  payload: data,
});

const resetRecordarContrasenaEvento = () => ({
  type: RESET_ERROR_RECORDAR_CONTRASENA,
  payload: true,
});
